import { StickyLabel } from '@intigral/shared';
import { getPathNameWithoutLangPrefix, resolveAppTheme, type AppThemeAudience } from '@intigral/utils';
import { useLocation } from 'react-router-dom';
import { isGuestUser } from '../../config/guestMode';
import user from '../../helpers/user';
import { useConfiguration } from '../../hooks/useConfiguration';
import useLanguage from '../../hooks/useLanguage';

const getAudience = (freeTierGuid?: string): AppThemeAudience => {
    const currentUser = user.getUserInfo();
    if (isGuestUser(currentUser)) return 'guest';

    const tierGuid = user.getUserActiveTierGuid();
    const hasFreeTier =
        Boolean(freeTierGuid) && (tierGuid === freeTierGuid || currentUser?.subscriptionGUID?.includes(freeTierGuid));
    return hasFreeTier ? 'free' : 'paid';
};

export const AppThemeOverlay = () => {
    const { pathname } = useLocation();
    const { data: config } = useConfiguration();
    const lang = useLanguage();
    const theme = resolveAppTheme(config?.themeConfig, {
        audience: getAudience(config?.freePlusTierConfig?.freeTierSettings?.subscriptionGUID),
        lang,
        platforms: ['wcp'],
    });

    if (getPathNameWithoutLangPrefix(pathname) !== '' || !theme) return null;

    return <StickyLabel src={theme.src} alt="" anchor="bottom-end" fixed reveal="fade" zIndex={11} />;
};
